import { Outlet } from 'react-router-dom';
import { SWRConfig } from 'swr';
import { AuthProvider } from './features/auth';
import { PresenceProvider } from './features/presence';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function RootLayout() {
  return (
    <SWRConfig value={{ provider: () => new Map() }}>
      <AuthProvider>
        <PresenceProvider>
          <Outlet />
          <ToastContainer limit={5} />
        </PresenceProvider>
      </AuthProvider>
    </SWRConfig>
  );
}
